var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDesktopRefreshIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.24198 7.78556C3.1617 4.19222 6.4342 1.66833 10.1773 1.66833C13.3856 1.66833 16.2517 3.50778 17.5992 6.37389H14.7759V8.04222H20.4867V2.41694H18.797V4.91944C17.0217 1.90361 13.7706 0 10.1773 0C5.60003 0 1.53615 3.22972 0.530868 7.65722L0.445312 7.99944H2.17781L2.24198 7.78556Z",
    fill: "black",
    fillOpacity: 0.7
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8187 11.2505L18.7545 11.4644C17.8348 15.0578 14.5623 17.5817 10.8192 17.5817C7.61088 17.5817 4.74477 15.7422 3.39727 12.8761H6.2206V11.2078H0.509766V16.8544H2.19949V14.3305C3.95338 17.3464 7.22588 19.25 10.7978 19.25C15.3964 19.25 19.4603 16.0203 20.4656 11.5928L20.5512 11.2505H18.8187Z",
    fill: "black",
    fillOpacity: 0.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesktopRefreshIcon);
export default __webpack_public_path__ + "static/media/desktop_refresh_icon.b93e31c7bf430a0d31c51c4948919196.svg";
export { ForwardRef as ReactComponent };